import { downloadFile } from '@/common/copyright/fileUtil'
import TsaCreateProcess from '@/components/copyright/business/copyrightDetail/createProcess'
import { dramaSearchApi } from '@/api/copyright/drama'
import { apiDramaCategorySearchList } from '@/api/copyright/common'
import { findDramaStageListApi, findDramaStageFilesApi } from '@/api/copyright/drama'
import tableConfig from '@/config/copyright/tableConfig'
import { categorysList } from '@/config/copyright/categorysList'
import { mapState, mapActions } from 'vuex'
import TsaSharePermissionsSetting from '@/components/copyright/business/sharePermissions/shareSettingDialog'
import TsaShareWorksDialog from '@/components/copyright/business/sharePermissions/shareWorksDialog'
import setupStatusList from '@/config/copyright/setupStatusList'
import commonDetail from '@/mixins/detail'
export default {
    components: {
        TsaCreateProcess,
        TsaShareWorksDialog, 
        TsaSharePermissionsSetting
    },
    mixins: [ commonDetail],
    data () {
        return {
            loading: true,
            condition: {
                page: 1,
                size: tableConfig['pageSize'],
                // 名称或描述
                nameOrDescription: '',
                // 申请人
                owner: '',
                createdAt: [],
                category: null,
                // 申请账号ID
                applyUserId: null,
                // 他人访问权限
                setupStatus: null,
            },
            list: [],
            categorysList,
            categoryList: [],
            setupStatusList,
            currentItem:{},
            currentIndex:null,
        }
    },
    computed: {
        ...mapState({
            parentIframe: (state) => state.app.parentIframe,
        }),
    },
    mounted () {
        this.$store.commit('app/addKeepAliveArray', 'TsaCertifiedWorkPage')
        this.init()
    },
    methods: {
        resetFilter () {
            this.condition = {
                page: 1,
                size: tableConfig['pageSize'],
                // 名称或描述
                nameOrDescription: '',
                // 权利人
                owner: '',
                // 申请人
                applyUserId: '',
                createdAt: [],
                category: null,
            }
            this.init('refresh')
        },
        serarch(){
            this.condition.page = 1
            this.init('refresh')
        },
        command (val, item, index) {
            this.currentItem=item;
            this.currentIndex=index;
            switch (val) {
                case 'gotoDetail':
                    this.gotoDetail(item)
                    break
                case 'downLoadCertificate':
                    this.downLoadCertificate(item)
                    break
                case 'shareWork':
                    this.shareWorks(item)
                    break
                case 'settingPermissions':
                    this.settingPermissions(item)
                    break
            }
        },
        scroll () {
            this.reset();
        },
        reset () {
           this.list.map((item, index) => {
                this.$refs.myDropdown[index] && this.$refs.myDropdown[index].hide()
           }) 
        },
        refresh () {
            this.reset()
            console.log('refresh')
            this.$refs.TsaPullToRefresh.setRefreshLoading(true)
            this.$refs.TsaPullToRefresh.setFinished(false)
            this.condition.page = 1
            this.init('refresh')
        },
        load () {
            console.log('load')
            this.condition.page++
            this.$refs.TsaPullToRefresh.setMoreLoading(true)
            this.init('load')
        },
        init (type) {
            if (type === 'refresh') {
                this.$TsaLoadingV2.show()
            }
            // 通用版权
            this.loading = true
            let condition = JSON.parse(JSON.stringify(this.condition))
            // 通用版权
            condition.type = -1
            dramaSearchApi(condition).then((res) => {
                this.$TsaLoadingV2.hide()
                if (res.code === 200) {
                    let data = res.data && res.data.data ? res.data.data : []
                    if (type === 'refresh') {
                        this.list = data
                        this.$refs.TsaPullToRefresh.setRefreshLoading(false)
                        this.$toast.clear()
                    } else {
                        this.list = [ ...this.list, ...data, ]
                    }
                    this.$nextTick(() => {
                        // 数据已经全部加载完成
                        if (data.length < this.condition.size) {
                            this.$refs.TsaPullToRefresh.setFinished(true)
                        } else {
                            
                        }
                        this.$refs.TsaPullToRefresh.setMoreLoading(false)
                    })
                } else {
                    if (type === 'refresh') {
                        this.$refs.TsaPullToRefresh.setRefreshLoading(false)
                    } else {
                        this.condition.page--
                        this.$refs.TsaPullToRefresh.setMoreLoading(false)
                    }
                }
            }).catch((err) => {
                this.$TsaLoadingV2.hide()
                if (type === 'refresh') {
                    this.$refs.TsaPullToRefresh.setRefreshLoading(false)
                } else {
                    this.condition.page--
                    this.$refs.TsaPullToRefresh.setMoreLoading(false)
                }
            });  
        },
        // 详情
        gotoDetail ({ id }) {
            this.$router.push({
                path: '/copyright/copyrightAuthDetail',
                query: {
                    id
                }
            })
            UserEventRecord.track(UserEventRecord.trackCommonCopyrightOperation, {
                '操作类型': '作品详情'
            })
        },
        // 下载证书
        downLoadCertificate ({ certStorePathUrl }) {
            UserEventRecord.track(UserEventRecord.trackCommonCopyrightOperation, {
                '操作类型': '下载作品证书'
            })
            let {parentIframe} =this
            if(parentIframe === 'ANDROID-RIGHTS' || parentIframe === 'IOS-RIGHTS' || parentIframe === 'HARMONYOSNEXT-RIGHTS' || parentIframe ==='WEIXIN'){
                this.$TsaAlertV2.show({
                    title: '下载证书',
                    message: '请用手机浏览器打开后进行下载证书，或者在电脑端打开<span style="word-break: break-all;">https://ipr.tsa.cn/copyright/certifiedWork</span>下载证书。',
                    type: 'warn',
                    confirmButtonText: '我知道了',
                    onConfirm: () => {
                        this.$TsaAlertV2.hide()
                    },
                })
            }else{
                downloadFile(certStorePathUrl)
            }
        },
        // 分享作品
        shareWorks (item) {
            this.detailHandleData(item)
            this.$refs.shareWorksDialog.open({
                id:item.id,
                rightsInfo: this.rightsInfo,
                basicInfo: this.basicInfo,
                certificateInfo: this.certificateInfo,
            })
        },
        // 分享设置成功
        permissionsSettingSuccess (obj) {
            this.$refs.sharePermissionsSettingDialog.hide()
            this.basicInfo.setupStatus = 1
            this.basicInfo.accessStatus = obj.accessStatus
            this.basicInfo.setupDuration = obj.setupDuration
            this.basicInfo.accessCode = obj.accessCode
            this.basicInfo.setupExpiredAt = obj.setupExpiredAt
            //分享成功后改变当前列表中的当前数据的分享状态
            this.currentItem.setupStatus=1;
            this.currentItem.setupDuration=obj.setupDuration;
            this.currentItem.accessStatus = obj.accessStatus
            this.currentItem.accessCode=obj.accessCode;
            this.currentItem.setupExpiredAt = obj.setupExpiredAt
            this.shareWorks(this.currentItem)
            this.$set(this.list, this.currentIndex, this.currentItem)
        },
        // 设置分享权限
        settingPermissionsCommon () {
            this.$refs.sharePermissionsSettingDialog.open({
                id: this.currentItem.id,
                rightsInfo: this.rightsInfo,
                basicInfo: this.basicInfo,
                certificateInfo: this.certificateInfo,
            })
        },
        // 设置访问权限
        settingPermissions (item) {
            this.detailHandleData(item)
            // 从来没设置过分享权限
            if (this.basicInfo.setupStatus === 0) {
                this.settingPermissionsCommon()
            } else if (this.basicInfo.setupStatus === 1) {
                this.shareWorks(this.currentItem)
            } else {
                this.$TsaToastV2.show({
                    message: '该作品设置访问权限失败',
                    type: 'error'
                })
            }
            
        },
    }
}